import { InfoOutlined } from '@mui/icons-material'
import { Box, Fade, IconButton, Tooltip, Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getNotDependents, showDependents } from '../../../../../../redux/actions/users'
import { IRootState } from '../../../../../../redux/types'
import CustomChip from '../../../../../shared/components/CustomChip'
import { useDependentsTable } from '../../hooks/detail/useDependentsTable'
import UserModal from '../modals/create/UserModal'
import UserTransferModal from '../modals/transfer/UserTransferModal'

function UserLinked({ userId }: { userId: number | null }) {
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()

  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { userProfileSelected, dependents, notdependents, showForm } = useSelector((state: IRootState) => state.user)

  const { rows, columns } = useDependentsTable()

  useEffect(() => {
    if (authUser !== null && userId) {
      if (dependents.length === 0) dispatch(showDependents(userId))
      if (notdependents.length === 0) dispatch(getNotDependents(userId))
    }
  }, [authUser])

  return (
    <>
      {authUser !== null && userProfileSelected !== null && (
        <>
          {showForm && <UserModal role_id={userProfileSelected.role_id} showBotton={false} />}
          <Grid container spacing={2}>
            <Grid xs={12}>
              <Box display="flex" flexDirection="column">
                <Box display="flex" justifyContent="center" width="100%">
                  <Typography variant="h5" align="center">
                    {t('admin.people.linked')}
                  </Typography>
                  <Tooltip
                    TransitionComponent={Fade}
                    TransitionProps={{ timeout: 600 }}
                    arrow
                    title={
                      <Box>
                        <Typography variant="body2">{t('status')}:</Typography>
                        <Box display="flex" gap={1} alignItems="center">
                          <CustomChip size="small" color={'primary'} />
                          <Typography variant="caption">{t('active')}</Typography>
                        </Box>
                        <Box display="flex" gap={1} alignItems="center">
                          <CustomChip size="small" color={'secondary'} />
                          <Typography variant="caption">{t('inactive')}</Typography>
                        </Box>
                      </Box>
                    }
                  >
                    <IconButton>
                      <InfoOutlined htmlColor={'#8F99A3'} fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
                {notdependents.length > 0 && <UserTransferModal />}
              </Box>
              <Box mt={2} mb={5} height="600px">
                <DataGrid
                  rows={rows}
                  columns={columns}
                  disableColumnFilter
                  disableDensitySelector
                  slots={{ toolbar: GridToolbar }}
                  slotProps={{
                    toolbar: {
                      showQuickFilter: true
                    }
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </>
      )}
    </>
  )
}

export default UserLinked
